<template>
  <div>
		<div style="margin-bottom:20px;">
      <h1 style="text-align:left;">合作伙伴</h1>
      <el-divider></el-divider>
    </div>
		<div>
      <div>
        <el-button type="text" @click="dialogFormVisible = true">添加合作伙伴</el-button>
        <el-dialog title="添加合作伙伴" :visible.sync="dialogFormVisible" :before-close="close">
          <el-form :model="form">
						<el-form-item label="合作方名字">
              <el-input v-model="form.info.partnername" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上传图片">
              <el-upload
                action="/upImg.php"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :on-remove="delete_file"
                :limit="1"
                :file-list="file_list"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;file_list = [];">取 消</el-button>
            <el-button type="primary" @click="addCarouse">提 交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
		<el-dialog title="修改合作伙伴" :visible.sync="modify_dialog" :before-close="close">
      <el-form :model="form">
        <el-form-item label="合作方名字">
          <el-input v-model="form.info.partnername" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传图片">
          <el-upload
            action="/upImg.php"
            list-type="picture-card"
            :on-success="handleAvatarSuccess"
            :on-remove="delete_file"
            :limit="1"
            :file-list="file_list"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modify_dialog = false;file_list = [];">取 消</el-button>
        <el-button type="primary" @click="confirmModifyCarouse">修 改</el-button>
      </div>
    </el-dialog>
		<el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column label="id" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
			<el-table-column label="公司名" width="180">
        <template slot-scope="scope">{{scope.row.info.partnername}}</template>
      </el-table-column>
      <el-table-column label="图" width="180">
        <template slot-scope="scope">{{scope.row.info.path}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="modify_carouse(scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row,tableData)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
	</div>
</template>

<style scoped>

</style>>

</style>

<script>
export default {
	name: 'partner_manage',
	data() {
		return {
			modify_dialog: false,
			dialogFormVisible: false,
			file_list: [],
			form: {
				info: {
					path: null,
					partnername: null
				}
			},
			tableData: [{
				id: "1",
				info: {
					path: "/upload/network.png",
					partnername: "华为技术有限公司"
				}
			}]
		}
	},
	methods: {
		modify_carouse(row) {
			this.modify_dialog = true;
			this.form = row;
			this.file_list.push({
        url: "/" + row.info.path,
        name: row.info.path
      });
      console.log(this.file_list);
		},
		handleDelete(index, row, rows) {
      var self = this;
      this.$confirm("是否删除该合作伙伴?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/partnermanage.php?id=" + row.id, "delete", null, function(data) {
            rows.splice(index, 1);
            self.$message({
              message: "删除成功",
              type: "success"
            });
          });
        })
        .catch(() => {});
		},
		confirmModifyCarouse() {
			var self = this;
			this.form.info = JSON.stringify(this.form.info);
			console.log(JSON.stringify(this.form));
      this.ajax("/partnermanage.php", "patch", JSON.stringify(this.form), function(data) {
        self.modify_dialog = false;
        self.ajax("/partnermanage.php", "get", null, function(data) {
         	var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
        });
        self.$message({
          message: "修改成功",
          type: "success"
        });
      });
		},
		close() {
      console.log("关闭");
      this.modify_dialog = false;
			this.dialogFormVisible = false;
			this.file_list = [];
		},
		addCarouse() {
			var self = this;
			var subdata = self.form.info;
      this.ajax("/partnermanage.php", "post", JSON.stringify(subdata), function(data) {
        self.dialogFormVisible = false;
        self.file_list = [];
        self.form.info.path = null;
        self.form.info.partnername = null;
        self.ajax("/partnermanage.php", "get", null, function(data) {
         	var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
        });
        self.$message({
          message: "添加成功",
          type: "success"
        });
      });
		},
		handleAvatarSuccess(response, file, fileList) {
      this.form.info.path = response.replace(/\s/g, "");
		},
		delete_file(file, fileList) {
      var self = this;
      var data = {
        path: self.form.info.path
      };
      this.ajax("/upImg.php", "delete", JSON.stringify(data), function(data) {
        self.form.info.path = null;
      });
    }
  },
  mounted() {
    var self = this;
    this.ajax("/partnermanage.php", "get", null, function(data) {
			var tableData = JSON.parse(data);
			for(let i=0;i<tableData.length;i++){
				tableData[i].info = JSON.parse(tableData[i].info);
			}
			self.tableData = tableData;
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/partner_manage.vue